import API from '../../../lib/commons/api'
import { getLabel, parse } from '../../../lib/commons/i18nLabel'

// 選択肢をカスタム列挙で管理している項目のコード。利用するものだけ宣言する。
export type CustomEnumCode = 'TIMEZONE' | 'REGISTRATION_STATUS' | 'MONTH'

export type CustomEnumValueDto = {
  value: string
  name: string
}

type CustomEnumValueResponse = {
  value: string
  name: string
  // ロケール別の表示名。`${言語コード}: ${表示名}`の配列で返る。
  nameI18n?: string[]
}

// プロジェクト等のグループごとに選択肢を上書きしない項目のみを扱うため、
// グループキー（groupKeys）は指定しない。
// 接続失敗時、api.tsのfetchラッパーは通知を出したうえで空の成功応答（json: {}）を
// 返す。「選択肢なし」として扱わず、かつ通知を重ねないよう、例外ではなく undefined を返す。
export const findCustomEnumValues = async (
  customEnumCode: CustomEnumCode
): Promise<CustomEnumValueDto[] | undefined> => {
  const response = await API.functional.request(
    'GET',
    '/api/v1/custom_enums/values',
    { customEnumCode }
  )
  if (!Array.isArray(response.json)) return undefined
  const values = response.json as CustomEnumValueResponse[]
  return values.map(value => ({
    value: value.value,
    // テナントが追加した値はnameI18nを持たないため、nameにフォールバックする。
    name: (value.nameI18n && getLabel(parse(value.nameI18n))) || value.name,
  }))
}
